import LoadingSongDetailView from './LoadingSongDetailView';

export default LoadingSongDetailView;
